module.exports = __webpack_public_path__ + "static/media/plntify-show.9810b713.png";